module.exports = __webpack_public_path__ + "static/device_desktop_apple_light-e9a6b566f1958ef2f931ca5f96cee0c5.png";